import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../environments/environment';
import { OrderResponse } from '../models/api-responses';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {

  static UpdateOrderMethod = 'UpdateOrder';
  static UpdateMenuMethod = 'UpdateMenu';
  connection: signalR.HubConnection;
  private isTryConnection: boolean;

  constructor() {
  }

  public init(token: string): void {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.url}/api/signal`, {accessTokenFactory: () => token})
      .build();
  }

  public connect(): void {
    if (!this.isTryConnection) {
      this.isTryConnection = true;
      this.connection.start()
        .then(() => {
        })
        .catch(err => {
          console.log('Error while starting connection: ' + err);
          setTimeout(() => this.connect(), 5000);
        })
        .finally(() => this.isTryConnection = false);

      this.connection.on(SignalrService.UpdateOrderMethod, (order: OrderResponse) => {
        console.warn('UpdateOrderEvent:', order);
      });

      this.connection.on(SignalrService.UpdateMenuMethod, () => {
        console.warn('UpdateMenuEvent');
      });
    }
  }

  public disconnect(): void {
    this.connection?.stop();
  }
}
